import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1To70 extends React.PureComponent {
  static minValue = 1;
  static maxValue = 70;

  static describeRank = rank => rank.toString();
  static getDefaultValue = () => [60, 70];

  static marks = {
    1: '1',
    10: '10',
    20: '20',
    30: '30',
    40: '40',
    50: '50',
    60: '60',
    70: '70',
  };

  render() {
    const { ...rest } = this.props;

    return (
      <LevelingRankPicker
        {...rest}
        min={Leveling1To70.minValue}
        max={Leveling1To70.maxValue}
        marks={Leveling1To70.marks}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1To70.js